import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

const TitleError = props => {
    const { t } = useTranslation()
    return (
        <>
            <h2>{t("misc:SeedListing.TitleHeadline")}</h2>

            <div>
                <NavLink to="/profile" end>
                    <p>{t("misc:Profile.InvalidTitleCount")}</p>
                    <ul>
                        <li>
                            {t("translation:CommonMsg.Glossary.Byname")} 1: {props.errors[0].length}
                        </li>{" "}
                        <li>
                            {t("translation:CommonMsg.Glossary.Byname")} 2: {props.errors[1].length}
                        </li>
                    </ul>
                </NavLink>
            </div>
            <hr />
        </>
    )
}

export default TitleError
